<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: { Datatable, vSelect },
  data() {
    return {
      ketersediaanTools: {
        loading: true,
        list: [],
        columns: [
          { width: "40%", label: "Level", name: "-" },
          { width: "20%", label: "Ada", name: "-" },
          { width: "20%", label: "Tidak Ada", name: "-" },
          { width: "20%", label: "%", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
      },
      ketersediaanPenyusun: {
        loading: true,
        list: [],
        columns: [
          { width: "40%", label: "Penyusun", name: "-" },
          { width: "10%", label: "1.Knowledgeable", name: "-" },
          { width: "10%", label: "2.Practitioner", name: "-" },
          { width: "10%", label: "3.Advandced", name: "-" },
          { width: "10%", label: "4.Mastery", name: "-" },
          { width: "10%", label: "%", name: "-" },
          { width: "10%", label: "Total", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
      },
      pelaksanaan: {
        loading: true,
        list: [],
        columns: [
          { width: "70%", label: "Pelaksanaan", name: "-" },
          { width: "30%", label: "Peserta", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
        filter: { selected: "All", options: ["All", "2024", "2025"] },
      },
      hasilPelaksanaan: {
        loading: true,
        list: [],
        columns: [
          { width: "40%", label: "Pelaksanaan", name: "-" },
          { width: "30%", label: "Memenuhi", name: "-" },
          { width: "30%", label: "Tidak Memenuhi", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
        filter: { selected: "All", options: ["All", "2024", "2025"] },
      },
    };
  },

  mounted() {
    this.fetchKetersediaanTools();
    this.fetchKetersediaanPenyusun();
    this.fetchPelaksanaan();
    this.fetchHasilPelaksanaan();
  },

  methods: {
    async fetchKetersediaanTools() {
      this.ketersediaanTools.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/ketersediaan-tools",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data ketersediaan tools" });
          return;
        }
        this.ketersediaanTools.list = res.data.data.list;
        this.ketersediaanTools.chart.series = res.data.data.series;
        this.ketersediaanTools.chart.labels = res.data.data.label;
        this.ketersediaanTools.loading = false;
        this.setKetersediaanToolsChart();
      });
    },

    setKetersediaanToolsChart() {
      this.ketersediaanTools.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Ketersediaan Tools Berdasarkan Level Profisiensi" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: { categories: this.ketersediaanTools.chart.labels },
        fill: { opacity: 1 },
        tooltip: { y: { formatter: (val) => val } },
      };
    },

    async fetchKetersediaanPenyusun() {
      this.ketersediaanPenyusun.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/ketersediaan-penyusun",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data ketersediaan penyusun" });
          return;
        }
        this.ketersediaanPenyusun.list = res.data.data.list;
        this.ketersediaanPenyusun.chart.series = res.data.data.series;
        this.ketersediaanPenyusun.chart.labels = res.data.data.label;
        this.ketersediaanPenyusun.loading = false;
        this.setKetersediaanPenyusunChart();
      });
    },

    setKetersediaanPenyusunChart() {
      this.ketersediaanPenyusun.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Ketersediaan Tools Berdasarkan Penyusun" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: { categories: this.ketersediaanPenyusun.chart.labels },
        fill: { opacity: 1 },
        tooltip: { y: { formatter: (val) => val } },
      };
    },

    async fetchPelaksanaan(tahun = "All") {
      this.pelaksanaan.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/pelaksanaan",
        params: { tahun },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data pelaksanaan" });
          return;
        }
        this.pelaksanaan.list = res.data.data.list;
        this.pelaksanaan.chart.series = res.data.data.series;
        this.pelaksanaan.chart.labels = res.data.data.label;
        this.pelaksanaan.loading = false;
        this.setPelaksanaanChart();
      });
    },

    setPelaksanaanChart() {
      this.pelaksanaan.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Pelaksanaan Asesmen Hard Competency" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
          categories: this.pelaksanaan.chart.labels,
          labels: { rotate: -45, style: { fontSize: "12px" }, trim: true },
        },
        fill: { opacity: 1 },
        tooltip: { y: { formatter: (val) => val } },
      };
    },

    async fetchHasilPelaksanaan(tahun = "All") {
      this.hasilPelaksanaan.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/hasil-pelaksanaan",
        params: { tahun },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data hasil pelaksanaan" });
          return;
        }
        this.hasilPelaksanaan.list = res.data.data.list;
        this.hasilPelaksanaan.chart.series = res.data.data.series;
        this.hasilPelaksanaan.chart.labels = res.data.data.label;
        this.hasilPelaksanaan.loading = false;
        this.setHasilPelaksanaanChart();
      });
    },

    setHasilPelaksanaanChart() {
      this.hasilPelaksanaan.chart.options = {
        chart: { type: "bar" },
        colors: ["#00E396", "#FF4560"],
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Hasil Asesmen Hard Competency" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
          categories: this.hasilPelaksanaan.chart.labels,
          labels: { rotate: -45, style: { fontSize: "12px" }, trim: true },
        },
        fill: { opacity: 1 },
        tooltip: { y: { formatter: (val) => val } },
      };
    },
  },
};
</script>

<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Level Profisiensi</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="ketersediaanTools.columns">
                <tbody>
                  <tr v-if="ketersediaanTools.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="ketersediaanTools.list.length < 1">
                    <td colspan="99" class="text-center">Data tidak tersedia</td>
                  </tr>
                  <tr v-else v-for="(row, key) in ketersediaanTools.list" :key="key">
                    <td>{{ row.level }}</td>
                    <td class="text-center">{{ row.ada }}</td>
                    <td class="text-center">{{ row.tidak_ada }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="ketersediaanTools.chart.series.length > 0"
                  class="apex-charts"
                  :options="ketersediaanTools.chart.options"
                  :series="ketersediaanTools.chart.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Penyusun</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="ketersediaanPenyusun.columns">
                <tbody>
                  <tr v-if="ketersediaanPenyusun.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="ketersediaanPenyusun.list.length < 1">
                    <td colspan="99" class="text-center">Data tidak tersedia</td>
                  </tr>
                  <tr v-else v-for="(row, key) in ketersediaanPenyusun.list" :key="key">
                    <td>{{ row.penyusun }}</td>
                    <td class="text-center">{{ row['1.Knowledgeable'] }}</td>
                    <td class="text-center">{{ row['2.Practitioner'] }}</td>
                    <td class="text-center">{{ row['3.Advanced'] }}</td>
                    <td class="text-center">{{ row['4.Mastery'] }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                    <td class="text-center">{{ row.total }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div>
                <apexchart
                  v-if="ketersediaanPenyusun.chart.series.length > 0"
                  class="apex-charts"
                  :options="ketersediaanPenyusun.chart.options"
                  :series="ketersediaanPenyusun.chart.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Pelaksanaan Asesmen Hard Competency</div>
            <div class="mb-3 d-flex justify-content-start">
              <v-select
                v-model="pelaksanaan.filter.selected"
                :options="pelaksanaan.filter.options"
                placeholder="Semua Tahun"
                @update:modelValue="fetchPelaksanaan($event)"
              />
            </div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="pelaksanaan.columns">
                <tbody>
                  <tr v-if="pelaksanaan.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="pelaksanaan.list.length < 1">
                    <td colspan="99" class="text-center">Data tidak tersedia</td>
                  </tr>
                  <tr v-else v-for="(row, key) in pelaksanaan.list" :key="key">
                    <td>{{ row.pelaksanaan }}</td>
                    <td class="text-center">{{ row.nilai }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="pelaksanaan.chart.series.length > 0"
                  class="apex-charts"
                  :options="pelaksanaan.chart.options"
                  :series="pelaksanaan.chart.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Hasil Asesmen Hard Competency</div>
            <div class="mb-3 d-flex justify-content-start">
              <v-select
                v-model="hasilPelaksanaan.filter.selected"
                :options="hasilPelaksanaan.filter.options"
                placeholder="Semua Tahun"
                @update:modelValue="fetchHasilPelaksanaan($event)"
              />
            </div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="hasilPelaksanaan.columns">
                <tbody>
                  <tr v-if="hasilPelaksanaan.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="hasilPelaksanaan.list.length < 1">
                    <td colspan="99" class="text-center">Data tidak tersedia</td>
                  </tr>
                  <tr v-else v-for="(row, key) in hasilPelaksanaan.list" :key="key">
                    <td>{{ row.pelaksanaan }}</td>
                    <td class="text-center">{{ row['memenuhi'] }}</td>
                    <td class="text-center">{{ row['tidak_memenuhi'] }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="hasilPelaksanaan.chart.series.length > 0"
                  class="apex-charts"
                  :options="hasilPelaksanaan.chart.options"
                  :series="hasilPelaksanaan.chart.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
